import { Task } from '@/api';
import { createContext } from 'react';

export interface TasksContextData {
    tasks: Task[];
    status: 'error' | 'success' | 'pending';
    fetchNextPage: () => void;
    isFetchingNextPage: boolean;
    hasNextPage: boolean;
    refetch: () => void;
}

export const TasksContext = createContext<TasksContextData | undefined>(
    undefined
);
